export default __webpack_public_path__ + "static/media/runPun.9e38b573.png";